/** Request abortado (Strict Mode, navegação ou cleanup de useEffect). */
export function isRequestCanceled(error: unknown): boolean {
  if (error == null) return false
  if (typeof error === 'object') {
    const err = error as { name?: string; code?: string; message?: string }
    if (err.name === 'CanceledError' || err.name === 'AbortError') return true
    if (err.code === 'ERR_CANCELED') return true
    if (
      err.message === 'canceled' ||
      err.message === 'CanceledError' ||
      err.message === 'AUTH_GUEST' ||
      err.message === 'AUTH_SESSION_TIMEOUT' ||
      err.message === 'AUTH_SESSION_INVALID'
    ) {
      return true
    }
  }
  return false
}
